import { RootState } from '..'
import { createSelector } from 'reselect'
import { IRegistration } from './interfaces'

// Registrations added in this session: these get priced, validated and submitted.
export const filterNewRegistrations = (registrations: IRegistration[]) =>
  registrations.filter((reg) => !reg.loadedFromBackend)

// Registrations that already exist on the server (loaded via token/code) and are read-only here.
export const filterExistingRegistrations = (registrations: IRegistration[]) =>
  registrations.filter((reg) => reg.loadedFromBackend)

export const getNewRegistrations = createSelector(
  (state: RootState) => state.registrations.list,
  filterNewRegistrations
)

export const getExistingRegistrations = createSelector(
  (state: RootState) => state.registrations.list,
  filterExistingRegistrations
)
